import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/react';
import { App } from './App';
import './index.css';

const publishableKey = import.meta.env?.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// With no key the app must still run in the zero-config demo mode, so Clerk is
// never mounted at all rather than mounted and failing.
createRoot(el).render(
  publishableKey ? <ClerkProvider publishableKey={publishableKey}>{app}</ClerkProvider> : app,
);
